import React, { useEffect, useState } from 'react'
import AppModal from '../../../components/organisms/CustomModal'
import { toggleModal, updateRefresher } from 'redux/app/app.action'
import { connect, useSelector } from 'react-redux'
import PageTitle from 'components/atoms/PageTitle'
import FormInput from 'components/atoms/FormInput'
import arrowUp from '../../../assets/svg/arrow-up.svg'
import arrowDown from '../../../assets/svg/arrow-down.svg'
import Select from 'components/atoms/SelectInput'
import RadioInput from 'components/atoms/RadioInputGroup'
import Button from 'components/atoms/Button'
import Alert from 'components/atoms/Alert'
import searchIcon from '../../../assets/svg/search-normal.svg'
import { BASE_URL, getRequest, loggedUser_baseURL, postRequest } from 'services/http'
import DropdownCard from 'components/atoms/Dropdown/DropdownCard'

const InviteBusiness = (props) => {
    const [loading, setLoading] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [countryDropdown, setCountryDropdown] = useState(false);
    const [selectInputCountry, setSelectInputCountry] = useState('');
    const [selectedPaymentChannel, setSelectedPaymentChannel] = useState('');
    const [selectedFeeRuleLocal, setSelectedFeeRuleLocal] = useState('');
    const [selectedFeeRuleInternational, setSelectedFeeRuleInternational] = useState('');
    const [selectedFeeAmountLocal, setSelectedFeeAmountLocal] = useState('');
    const [selectedFeeAmountInternational, setSelectedFeeAmountInternational] = useState('');
    const [countryList, setCountryList] = useState<any>([]);
    const [paymentCapAmount, setPaymentCapAmount] = useState('');

    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [businessName, setBusinessName] = useState('');
    const [businessEmail, setBusinessEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [businessCountry, setBusinessCountry] = useState('');

    const [errMssg, setErrMssg] = useState(false);
    const [firstnameErr, setFirstnameErr] = useState('');
    const [lastnameErr, setLastnameErr] = useState('');
    const [businessNameErr, setBusinessNameErr] = useState('');
    const [businessEmailErr, setBusinessEmailErr] = useState('');
    const [phoneNumberErr, setPhoneNumberErr] = useState('');
    const [selectInputCountryErr, setSelectInputCountryErr] = useState('');

    const inputAlpha = /^[a-zA-Z ]*$/;
    const inputNum = /^[0-9]*$/;
    const noSpecialChar = /^[a-zA-Z0-9 ]*$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const countries = useSelector((state: any) => state.app.countries);

    const formComplete = firstname !== "" &&
        lastname !== "" &&
        businessEmail !== "" &&
        businessName !== "" &&
        phoneNumber !== '' &&
        selectedCountry !== '' &&
        selectInputCountry !== '';

    const disabledBtn = !formComplete || loading;

    const inviteBusiness = async (requestData: any) => {
        setLoading(true);
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${props.user_authData?.token.token}`,
            "Public-Key": `${props.publicKey}`
        }
        const res = await postRequest(`${BASE_URL + loggedUser_baseURL}invite`, headers, requestData);

        if (res?.data.responseCode === '00') {
            setLoading(false);
            Alert('success', res?.data?.message);
            props.setShowModal(false);
            props.updateRefresher();
        } else {
            res?.data?.message ? Alert('error', res?.data?.message) : res?.data?.detail && Alert('error', res?.data?.detail);
            setLoading(false);
        }
    }

    const handleSubmit = e => {
        e.preventDefault();

        const requestData = {
            name: firstname + ' ' + lastname,
            businessName: businessName,
            email: businessEmail,
            countryCode: selectedCountry,
            partnerId: `1`,
            phoneNumber: phoneNumber
        }

        if (formComplete) {
            if (emailRegex.test(businessEmail)) {
                inviteBusiness(requestData);
            } else {
                Alert('error', 'Please, Enter a valid Email Address');
            }
        } else {
            Alert('error', 'Please, fill all fields.');

            if (!selectedCountry) {
                setErrMssg(true);
                setSelectInputCountryErr('Country cannot be empty.');

                setTimeout(() => {
                    setErrMssg(false);
                }, 5000);
            }
            if (!firstname) {
                setErrMssg(true);
                setFirstnameErr('Invalid Firstname');

                setTimeout(() => {
                    setErrMssg(false);
                }, 5000);
            }
            if (!lastname) {
                setErrMssg(true);
                setLastnameErr('Invalid Lastname');

                setTimeout(() => {
                    setErrMssg(false);
                }, 5000);
            }
            if (!businessName) {
                setErrMssg(true);
                setBusinessNameErr('Business name cannot be empty.');

                setTimeout(() => {
                    setErrMssg(false);
                }, 5000);
            }
            if (!phoneNumber) {
                setErrMssg(true);
                setPhoneNumberErr('Phone number cannot be empty.');

                setTimeout(() => {
                    setErrMssg(false);
                }, 5000);
            }
            if (!businessEmail) {
                setErrMssg(true);
                setBusinessEmailErr('Invalid Business email address');

                setTimeout(() => {
                    setErrMssg(false);
                }, 5000);
            }
        }
    }

    const handleSelectCountry = (item) => {
        setSelectedCountry(item.countryCode);
        setSelectInputCountry(item.name);
        setCountryDropdown(false);
    }

    const filteredCountries = countries?.filter(item => {
        if (item.name.toLowerCase().includes(selectInputCountry.toLowerCase())) {
            return item;
        }
        else {
            return;
        }
    })

    useEffect(() => {
        if (countryDropdown) setSelectInputCountry('');
    }, [countryDropdown]);

    return (
        <AppModal
            handleClose={() => props.setShowModal(false)}
            modalStyle="max-w-sm w-full mobile:w-4/5 bg-white z-30 top-0 bottom-0 left-0 mx-auto h-fit z-30 right-0 p-5 tablet:p-4 rounded-xl animate-slide_up shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all overflow-hidden"
            contentStyle="h-fit flex flex-col gap-3 justify-between"
            closeBtnStyle='hidden'
        >
            <form onSubmit={handleSubmit} className='flex flex-col gap-3 justify-between'>
                <div className={`overflow-y-hidden h-full min-h-fit flex flex-col justify-between`}>
                    <PageTitle
                        pageTitle='Basic details'
                        subTitle='Enter the email of the business to find their accounts'
                        style='!mt-0 !gap-0'
                    />

                    <div className={`w-full h-fit max-h-[60vh] overflow-y-scroll flex flex-col gap-3 rounded-md`}>

                        <div className='w-full flex mobile:flex-col items-start gap-5'>
                            <FormInput
                                type={'text'}
                                name={'firstName'}
                                placeholder='Enter Firstname'
                                style='w-full'
                                inputStyle='border border-transparent text-Black2 w-full'
                                label='Firstname'
                                labelStyle='font-semibold text-sm leading-6 text-Black2'
                                value={firstname}
                                validationErr={errMssg && firstnameErr}
                                onChange={e => {
                                    if (inputAlpha.test(e.target.value)) {
                                        setFirstname(e.target.value);
                                    }
                                }}
                            />

                            {/* noSpecialChar */}
                            <FormInput
                                type={'text'}
                                name={'lastName'}
                                placeholder='Enter Lastname'
                                style='w-full'
                                inputStyle='border border-transparent text-Black2 w-full'
                                label='Lastname'
                                labelStyle='font-semibold text-sm leading-6 text-Black2'
                                value={lastname}
                                validationErr={errMssg && lastnameErr}
                                onChange={e => {
                                    if (inputAlpha.test(e.target.value)) {
                                        setLastname(e.target.value)
                                    }
                                }}
                            />
                        </div>

                        <div className='w-full relative z-[22]'>
                            <div className='flex flex-col gap-2'>
                                <label className='font-semibold text-sm leading-6 text-Black2'>Country</label>
                                <div className='border border-transparent rounded-md text-Black2 w-full bg-white flex justify-between items-center cursor-pointer' onClick={() => setCountryDropdown(prevState => !prevState)}>
                                    <span className='w-full p-2'>
                                        {selectInputCountry === '' ? 'Select Country' : selectInputCountry.length > 35 ? selectInputCountry.slice(0, 35) + "..." : selectInputCountry}
                                    </span>
                                    <img src={countryDropdown ? arrowUp : arrowDown} alt='' className='w-4 h-4 mx-4 cursor-pointer' />
                                </div>
                                {errMssg && selectInputCountryErr &&
                                    <div className="f-span text-right mt-2">
                                        <span className="text-xs font-medium text-red-500">
                                            {selectInputCountryErr}
                                        </span>
                                    </div>
                                }
                            </div>

                            {countryDropdown &&
                                <DropdownCard
                                    handleClickOut={setCountryDropdown}
                                    cardLayout={`min-w-[150px] w-3/4 max-h-[250px] flex flex-col gap-0 absolute z-20 right-0 top-20 p-1 bg-white rounded-md shadow-[0_8px_30px_rgb(0,0,0,0.12)] h-fit animate-slide_down2`}
                                >
                                    <FormInput
                                        type="text"
                                        placeholder='Search for Country'
                                        style={` w-full relative z-[15]`}
                                        inputStyle={`border border-transparent text-Black2 w-full bg-white`}
                                        value={selectInputCountry.length > 40 ? selectInputCountry.slice(0, 40) + "..." : selectInputCountry}
                                        onChange={e => {
                                            inputAlpha.test(e.target.value) && setSelectInputCountry(e.target.value);

                                            if (e.target.value.length >= 1) {
                                                setCountryDropdown(true);
                                            } else {
                                                setCountryDropdown(false);
                                            }
                                        }}
                                        img={searchIcon}
                                        imgStyle='w-4 h-4'
                                    />
                                    <div className='overflow-scroll flex flex-col gap-0'>
                                        {filteredCountries?.length === 0
                                            ? <span className='cursor-default font-normal text-sm leading-6 text-Primary rounded-md p-2 hover:bg-BackDrop_d_xs'>
                                                Not found
                                            </span>

                                            : filteredCountries?.map((item: any, i) => (
                                                <span key={i} onClick={() => handleSelectCountry(item)} className='cursor-pointer font-normal text-sm leading-6 text-Black2 rounded-md p-2 hover:bg-BackDrop_d_xs'>
                                                    {item.name.length > 20 ? item.name.slice(0, 20) + "..." : item.name}
                                                </span>
                                            ))}
                                    </div>
                                </DropdownCard>
                            }
                        </div>

                        <FormInput
                            type={'text'}
                            name={'businessName'}
                            placeholder='Enter Business Name'
                            style='w-full'
                            inputStyle='border border-transparent text-Black2 w-full'
                            label='Business Name'
                            labelStyle='font-semibold text-sm leading-6 text-Black2'
                            value={businessName}
                            validationErr={errMssg && businessNameErr}
                            onChange={e => {
                                // if (noSpecialChar.test(e.target.value) && 
                                if (e.target.value.length <= 225) {
                                    setBusinessName(e.target.value);
                                }
                            }}
                        />

                        <FormInput
                            type={'text'}
                            name={'phoneNumber'}
                            placeholder='Enter Phone number'
                            style='w-full'
                            inputStyle='border border-transparent text-Black2 w-full'
                            label='Phone Number'
                            labelStyle='font-semibold text-sm leading-6 text-Black2'
                            value={phoneNumber}
                            validationErr={errMssg && phoneNumberErr}
                            onChange={e => {
                                if (inputNum.test(e.target.value) && e.target.value.length <= 11) {
                                    setPhoneNumber(e.target.value);
                                }
                            }}
                        />

                        <FormInput
                            type={'text'}
                            name={'businessEmail'}
                            placeholder='Enter Business Email'
                            style='w-full'
                            inputStyle='border border-transparent text-Black2 w-full'
                            label='Business Email'
                            labelStyle='font-semibold text-sm leading-6 text-Black2'
                            value={businessEmail}
                            validationErr={errMssg && businessEmailErr}
                            onChange={e => {
                                if (e.target.value.length <= 225) {
                                    setBusinessEmail(e.target.value);
                                }
                            }}
                        />
                    </div>
                </div>

                <div className='w-full flex justify-between items-center gap-3'>
                    <span className='text-PrimaryActive font-normal text-[15px] leading-5 cursor-pointer' onClick={() => props.setShowModal(false)}>Cancel</span>
                    <Button
                        btnType='submit'
                        btnText={
                            loading
                                ? "Processing..."
                                : "Invite"
                        }
                        btnStyle={`${disabledBtn && 'bg-GrayCustom !cursor-not-allowed'} bg-DarkBg3 text-white font-normal text-[15px] leading-5 px-6 py-3 w-[30%] mobile:w-2/4`}
                        // disabled={disabledBtn}
                        onClick={() => { }}
                    />
                </div>
            </form>
        </AppModal>
    )
}

const mapStateToProps = state => ({
    user_authData: state.auth.user_authData,
    businessId: state.auth.user_authData.subPartnerId,
    publicKey: state.auth.user_authData.live_public_key,
    appState: state
});

const mapDispatchToProps = dispatch => ({
    updateRefresher: () => dispatch(updateRefresher())
});

export default connect(mapStateToProps, mapDispatchToProps)(InviteBusiness);